import { useEntitiesContext } from 'entities/EntitiesExport'

/**
 * In-app AI agent gate: the ConfigCat-backed web_ai_agent flag. Off by default.
 * Call from inside an `observer` component so flag hydration re-renders.
 */
export const useAiAgentEnabled = (): boolean => {
  const { featureFlagsStore } = useEntitiesContext()
  return featureFlagsStore.web_ai_agent
}
